;(function () {
  'use strict'

  angular
    .module('contrast.attacks')
    .constant('ATTACK_SORTS', {
      STATUS: ['BLOCKED', 'PROBED', 'EXPLOITED'],
      APP_IMPORTANCE: ['UNIMPORTANT', 'LOW', 'MEDIUM', 'HIGH', 'CRITICAL'],
      SERVER_ENVIRONMENT: ['DEVELOPMENT', 'QA', 'PRODUCTION'],
      SEVERITY: ['LOW', 'MEDIUM', 'HIGH']
    })
    .constant('ATTACK_DISCUSSION_EVENTS', {
      DELETE: 'attack.discussion.delete',
      ADD: 'attack.discussion.add',
      UPDATE: 'attack.discussion.update'
    })
})()
